import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const assignUserToGroups = async (id, updatedGroups) => {
  try {
    const response = await apiClient.put(`/users/assignUserGroups/${id}`, updatedGroups);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
